// extracted by mini-css-extract-plugin
export default {"circularImage":"styles_circularImage__Ap4hy"};